import type { ShowroomItem, VisualNavigationItemData } from '../../../types/visual-navigation';
import { composePrismicImageUrl, slideImageOptions } from './utils';

export const transformShowroomItems = (
  showroomItems: ShowroomItem[]
): VisualNavigationItemData[] => {
  const { x1, x2, x3, thumbnail } = slideImageOptions;

  return showroomItems.map(({ image, name, link: { fullUrl: link } }) => ({
    description: name,
    link,
    image: {
      x1: composePrismicImageUrl(image.original.url, x1),
      x2: composePrismicImageUrl(image.original.url, x2),
      x3: composePrismicImageUrl(image.original.url, x3),
      thumbnail: composePrismicImageUrl(image.original.url, thumbnail),
      alt: name,
    },
  }));
};
